import { Link } from "react-router-dom";
import { SectionLink } from "../../../components/SectionLink.tsx";
import { assets, footerColumns } from "../data.ts";

const linkClass = "text-sm text-white/70 no-underline transition-colors hover:text-white";

const legalLinks: { label: string; href: string; external?: boolean }[] = [
  { label: "Privacy", href: "#" },
  { label: "Terms", href: "#" },
  { label: "Instagram", href: "https://www.instagram.com/restomagofficial", external: true },
  { label: "YouTube", href: "#" },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-white/[.08] bg-black px-5 pb-11 pt-16 md:px-8 lg:px-12 lg:pt-20">
      <div className="mx-auto max-w-shell">
        <div className="grid grid-cols-1 gap-12 border-b border-white/[.09] pb-14 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr]">
          <div>
            <div className="mb-5 flex items-center gap-[13px]">
              {/* Plain wordmark (no baked-in tagline) — the "Land · Sea · Air" line below carries it. */}
              <img src={assets.wordmark} alt="RestoMag" className="block h-5 w-auto" />
              <span className="h-[18px] w-px bg-white/[.26]" />
              <span className="font-mono text-[11.5px] uppercase tracking-[.24em] text-flame">Events</span>
            </div>
            <p className="m-0 mb-[22px] max-w-[34ch] text-[14.5px] leading-[1.6] text-white/55">
              The home of enthusiast events. Land, sea and air — where the culture comes together.
            </p>
            <div className="font-mono text-xs uppercase tracking-[.16em] text-white/40">Land · Sea · Air</div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.heading}>
              <div className="mb-[18px] font-mono text-[11px] uppercase tracking-[.18em] text-white/40">
                {col.heading}
              </div>
              <div className="flex flex-col gap-3">
                {col.links.map((link, i) =>
                  link.href.startsWith("/") ? (
                    <Link key={`${link.label}-${i}`} to={link.href} className={linkClass}>
                      {link.label}
                    </Link>
                  ) : (
                    <SectionLink key={`${link.label}-${i}`} section={link.href.slice(1)} className={linkClass}>
                      {link.label}
                    </SectionLink>
                  ),
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-between gap-5 pt-[26px]">
          <div className="font-mono text-[11.5px] text-white/[.38]">© 2026 RestoMag · events.restomag.com</div>
          <div className="flex gap-[22px]">
            {legalLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className="text-[12.5px] text-white/50 no-underline transition-colors hover:text-white"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
